module.exports = __webpack_public_path__ + "media/4a6d32c6bf8a4a6d938f154d70589a39.6fb86614.mp4";